var moment = require('moment');
var _ = require('underscore');
var helper = {};

helper.substractOneUnit = function (timestamp, aggregation) {
  if (!_.isNumber(timestamp)) {
    return timestamp;
  }

  var result = moment.unix(timestamp).utc();
  aggregation && aggregation === 'week'
    ? result.subtract(1, 'day')
    : result.subtract(1, aggregation);

  return result.unix();
};

module.exports = helper;



//////////////////
// WEBPACK FOOTER
// ./lib/assets/javascripts/deep-insights/util/timestamp-helper.js
// module id = 611
// module chunks = 0 2